import { ActionButtonStyle } from './Types/Types';
import { DisplayStyle, ButtonDisplayStyle, ButtonDisplaySize, IconTypes } from '../Enums/UiEnums';
import { ICssLength, CssLength, CssLayoutUnits } from './CssHelpers';
import { bootstrapButtonClass } from './StyleHelpers';

export interface IButtonProps
{
    action?: ActionButtonStyle,
    displayStyle?: DisplayStyle | ButtonDisplayStyle,
    size?: ButtonDisplaySize,
    contextValue?: string | number;
    text?: string,                      // Override default text -- Only use if you don't use the slot
    class?: string,                     // Override default CSS class
    icon?: IconTypes,                   // Override default icon
    disabled?: boolean,
    width?: ICssLength|number|Object,          // Width of the button.  Current in px but should change to em/ex/ch
    tooltip?: string,                   // Tooltip for the button
    iconDisplayStyle?: DisplayStyle,    // Style for action icon
}

export function getButtonClass(props: IButtonProps) {
    return props.class ?? bootstrapButtonClass(props.displayStyle, props.size) ?? "btn btn-primary";
}

export function getButtonStyle(props: IButtonProps){
    if (typeof(0) === typeof(props.width))
    {
        return props.width ? `width: ${new CssLength(props.width as number, CssLayoutUnits.px).cssValue};` : undefined
    }
    const cssLength = props.width as ICssLength;
    return props.width ? `width: ${new CssLength(cssLength.amount, cssLength.units).cssValue};` : undefined
}